export const SET_ACTIVE_DATE = 'set_active_date';
export const INITIALIZE_RESEQUENCING_FLOW = 'initialize_resequencing_flow';
export const END_RESEQUENCING_FLOW = 'end_resequencing_flow';
